import * as React from 'react'
import { Action } from 'redux-actions'
import { all, call, put, select, take, takeEvery } from 'redux-saga/effects'
import { t } from 'ttag'
import { doLogOut, getWhoAmI, getWhoAmIFail, getWhoAmISuccess } from '../../../common/auth/authActions'
import { addNotification, clearNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import { store } from '../../../index'
import api from '../../../services/api.services'
import {
  ActivityProgress,
  CompanyCountriesDto,
  DivisionDto,
  JoinCompany$Request,
  LeaveCompany$Request,
  ProgressType,
  ScreenOrientation,
  ServiceProvider,
  SetUserCountry$Request,
  SetUserDivision$Request,
  UpdateUserProfile$Request,
  UserProfileDto,
  JoinCompany$Response,
  CompanyId,
} from '../../../services/api.types'
import { applyScreenOrientation } from '../../../common/helpers/screenOrientation'
import { IChangePasswordPayload } from '../Settings'
import {
  changePassword,
  changePasswordFail,
  deleteUser,
  getUserCompanyCountries,
  getUserCompanyCountriesSuccess,
  getCompanyDivisions,
  getCompanyDivisionsSuccess,
  /*getUserActivity,
  getUserActivitySuccess,
  getUserBadges,
  getUserBadgesSuccess,*/
  updateUser,
  joinCompany,
  joinCompanyLoading,
  joinCompanySuccess,
  setUserDivision,
  setUserCountry,
  leaveCompany,
  togglePublicStatus,
  deleteUserOwnedCompany,
  setJoinedCompanyId,
  getCompanyDivisionsFail,
  getUserCompanyCountriesFail,
  updateUserCompanyProfile,
  updateUserCompanyProfileLoading,
  updateUserCompanyProfileSuccess,
  updateUserCompanyProfileFail,
  setScreenOrientation,
} from './SettingsActions'
import { getUserDto } from '../../../common/auth/authSelectors'
import { getErrorMsg } from '../../../common/helpers/translations'
import { scrollToTop } from '../../../common/helpers/scroll'
import { push } from 'connected-react-router'
import { ROUTES } from '../../../common/Routes/routePaths'

/*function* sagaGetUserActivity({ payload }: Action<UserProfileDto>) {
  try {
    const { createdAt, userId } = payload
    const { activityProgress }: { activityProgress: ActivityProgress } = yield call(
      api.activity.getUserActivityProgressInPeriod,
      {
        endDate: startOfDay(addDays(new Date(), 1)).getTime(),
        progressType: ProgressType.ALL,
        startDate: startOfDay(createdAt).getTime(),
        userId,
      } as any,
    )
    yield put({ type: String(getUserActivitySuccess), payload: activityProgress })
  } catch (e: any) {
    const getUserActivityErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('user activity load'),
    }

    yield put({ type: String(addNotification), payload: getUserActivityErrorNotification })
  }
}*/

function* sagaGetUserCompanyCountries(action: Action<{ companyId?: CompanyId } | undefined>) {
  try {
    const companyId = action?.payload?.companyId
    const { companyCountries }: { companyCountries: CompanyCountriesDto[] } = companyId
      ? yield call(api.users.getCompanyCountries, { companyId })
      : yield call(api.users.getUserCompanyCountries)
    yield put({ type: String(getUserCompanyCountriesSuccess), payload: companyCountries })
  } catch (e: any) {
    yield put({ type: String(getUserCompanyCountriesFail) })
    /*const ErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('countries load'),
    }
    yield put({ type: String(addNotification), payload: ErrorNotification })*/
    /*Bugsnag.notify(new Error('getUserCompanyCountries error'), function (event) {
      event.context = 'getUserCompanyCountries'
      event.addMetadata('error', e)
    })*/
  }
}

function* sagaGetCompanyDivisions(action: Action<{ companyId?: CompanyId } | undefined>) {
  try {
    const companyId = action.payload?.companyId || (null as unknown as CompanyId)
    //const { divisionDtos }: { divisionDtos: DivisionDto[] } = yield call(api.users.getCompanyDivisions)
    const { divisionDtos }: { divisionDtos: DivisionDto[] } = yield call(api.users.getDivisions, {
      companyId,
    })
    yield put({ type: String(getCompanyDivisionsSuccess), payload: divisionDtos })
  } catch (e: any) {
    yield put({ type: String(getCompanyDivisionsFail) })
    /*const ErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('groups load'),
    }
    yield put({ type: String(addNotification), payload: ErrorNotification })*/
    /*Bugsnag.notify(new Error('getCompanyDivisionsSuccess error'), function (event) {
      event.context = 'getCompanyDivisionsSuccess'
      event.addMetadata('error', e)
    })*/
  }
}

function* sagaUpdateUser({ payload }: Action<UpdateUserProfile$Request>) {
  try {
    const {
      dateOfBirth,
      firstName,
      gender,
      height,
      lastName,
      phone,
      weight,
      divisionId,
      country,
      ssn,
      timeZone,
      units,
      //newsletterSubscriber,
      onlyProfileUpdate,
    } = payload

    yield call(api.activity.updateUserProfile, {
      dateOfBirth,
      firstName,
      gender,
      height,
      lastName,
      phone,
      weight,
      divisionId: divisionId ? divisionId : null,
      country,
      ssn,
      timeZone,
      units,
      // Deprecated
      //newsletterSubscriber,
      onlyProfileUpdate,
    })

    // Update userDto...
    yield put({ type: String(getWhoAmI) })

    const updateUserSuccessNotification: INotification = {
      type: 'success',
      content: t`User successfully updated`,
    }

    yield put({ type: String(addNotification), payload: updateUserSuccessNotification })

    scrollToTop()
  } catch (e: any) {
    // Update userDto...
    yield put({ type: String(getWhoAmI) })

    const updateUserFailNotification: INotification = {
      type: 'warning',
      content: t`Profile details missing. Last profile data synchronized`,
    }

    yield put({ type: String(addNotification), payload: updateUserFailNotification })
  }
}

function* sagaDeleteUser(action: Action<any>) {
  try {
    yield call(api.users.deleteUser, action.payload)
    yield put({ type: String(doLogOut) })
    const deleteUserSuccessNotification: INotification = {
      type: 'success',
      content: t`User successfully deleted`,
    }

    yield put({ type: String(addNotification), payload: deleteUserSuccessNotification })
  } catch (e: any) {
    const deleteUserErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('user deletion'),
    }

    yield put({ type: String(addNotification), payload: deleteUserErrorNotification })
  }
}

function* sagaChangePassword({ payload }: any) {
  try {
    const { oldPassword, newPassword, confirmPassword }: IChangePasswordPayload = payload
    if (newPassword !== confirmPassword) {
      const changePasswordInvalidNotification: INotification = {
        type: 'warning',
        content: t`Confirmation password does not match new password`,
      }

      yield put({ type: String(addNotification), payload: changePasswordInvalidNotification })

      return
    }
    yield call(api.auth.changePassword, {
      newPassword,
      oldPassword,
    })

    yield put({ type: String(doLogOut), payload: { skipRedirect: true } })
    const notification: INotification = {
      type: 'success',
      content: t`Password successfully changed`,
    }
    yield put(push(ROUTES.LOGIN.to, { notification }))
    // yield put({ type: String(addNotification), payload: changePasswordSuccessNotification })
  } catch (e: any) {
    let msg = e.message
    const isIncorrectOldPassword = msg === 'incorrectOldPassword'
    if (isIncorrectOldPassword) msg = t`Incorrect old password. Please try again.`

    // For known field errors we show the message inline next to the offending input,
    // so skip the top-of-page notification to avoid duplicating it.
    if (!isIncorrectOldPassword) {
      const changePasswordErrorNotification: INotification = {
        type: 'warning',
        content: msg || getErrorMsg('password change'),
      }
      yield put({ type: String(addNotification), payload: changePasswordErrorNotification })
    }

    yield put({
      type: String(changePasswordFail),
      payload: { oldPasswordError: isIncorrectOldPassword ? msg : '' },
    })
  }
}

function* sagaJoinCompany(action: Action<JoinCompany$Request>) {
  try {
    yield put({ type: String(clearNotification) })

    // Set loading state to true
    yield put({ type: String(joinCompanyLoading), payload: true })

    const response: JoinCompany$Response = yield call(api.activity.joinCompany, action.payload)

    //console.log('Join company API response:', response)

    // Store the joined company ID
    if (response && response.userCompanyId) {
      // The userCompanyId is the correct ID to use - it's of type UserCompanyId
      //console.log('Setting joined company ID (userCompanyId):', response.userCompanyId)
      yield put({ type: String(setJoinedCompanyId), payload: response.userCompanyId })
    } else {
      //console.log('No userCompanyId found in response')
    }

    // Call only if integration is set (to prevent error).
    const userDto: UserProfileDto = yield select(getUserDto)
    const serviceProvider = userDto.serviceProvider as ServiceProvider
    if (serviceProvider) {
      yield call(api.activity.syncUserThirdPartyData)
    }

    // Load teams again...
    // ... and wait until they are finished!
    yield put({ type: String(getWhoAmI) })
    yield take([String(getWhoAmISuccess), String(getWhoAmIFail)])
    yield put({ type: String(getCompanyDivisions) })
    yield take([String(getCompanyDivisionsSuccess), String(getCompanyDivisionsFail)])
    yield put({ type: String(getUserCompanyCountries) })
    yield take([String(getUserCompanyCountriesSuccess), String(getUserCompanyCountriesFail)])

    // Set successful join
    yield put({ type: String(joinCompanySuccess) })

    /*const successNotification: INotification = {
      type: 'success',
      content: t`Successfully joined`,
    }
    yield put({ type: String(addNotification), payload: successNotification })*/
  } catch (e: any) {
    // Set loading state back to false on error
    yield put({ type: String(joinCompanyLoading), payload: false })
    // Clear the joined company ID on error
    yield put({ type: String(setJoinedCompanyId), payload: null })

    if (e.message && e.message === 'ssoRequired') {
      const signupErrorNotification: INotification = {
        type: 'warning',
        content: t`This company requires SSO login. You cannot join using a sign-up code.`,
      }
      yield put({ type: String(addNotification), payload: signupErrorNotification })
    } else if (e.message && e.message === 'invalidCompanyCode') {
      const signupErrorNotification: INotification = {
        type: 'warning',
        content: t`Sorry, the sign-up code provided is not valid`,
      }
      yield put({ type: String(addNotification), payload: signupErrorNotification })
    } else if (e.message && e.message === 'disallowedDomain') {
      const signupErrorNotification: INotification = {
        type: 'warning',
        content: t`Sorry, the sign-up code provided does not allow signing up with the specified email address. Please sign up using another email address or contact your employer.`,
      }
      yield put({ type: String(addNotification), payload: signupErrorNotification })
    } else if (e.message && e.message === 'disallowedRegion') {
      const signupErrorNotification: INotification = {
        type: 'warning',
        content: t`Sorry, the given sign-up code does not allow signing up from your region.`,
      }
      yield put({ type: String(addNotification), payload: signupErrorNotification })
    } else if (e.message && e.message === 'userLimitExceeded') {
      const signupErrorNotification: INotification = {
        type: 'warning',
        content: t`Sorry, this community has exceeded its user limit. Please contact your challenge organizer for more info.`,
      }
      yield put({ type: String(addNotification), payload: signupErrorNotification })
    } else {
      const toggleErrorNotification: INotification = {
        type: 'warning',
        content: getErrorMsg('joining'),
      }
      yield put({ type: String(addNotification), payload: toggleErrorNotification })
    }
  }
}

function* sagaLeaveCompany(action: Action<LeaveCompany$Request>) {
  try {
    const { companyName } = yield api.users.leaveCompany(action.payload)

    yield put({ type: String(getWhoAmI) })
    yield put({ type: String(getCompanyDivisions) })
    yield put({ type: String(getUserCompanyCountries) })

    const successNotification: INotification = {
      type: 'success',
      content: t`Successfully left ${companyName}`,
    }
    yield put({ type: String(addNotification), payload: successNotification })
  } catch (e: any) {
    const toggleErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('leaving'),
    }

    yield put({ type: String(addNotification), payload: toggleErrorNotification })
  }
}

function* sagaDeleteUserOwnedCompany(action: Action<LeaveCompany$Request>) {
  try {
    const { companyName } = yield api.users.deleteUserOwnedCompany(action.payload)

    yield put({ type: String(getWhoAmI) })
    yield put({ type: String(getCompanyDivisions) })
    yield put({ type: String(getUserCompanyCountries) })

    const successNotification: INotification = {
      type: 'success',
      content: t`Successfully deleted ${companyName}`,
    }
    yield put({ type: String(addNotification), payload: successNotification })
  } catch (e: any) {
    const toggleErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('user community deletion'),
    }

    yield put({ type: String(addNotification), payload: toggleErrorNotification })
  }
}

function* sagaSetUserDivision(action: Action<SetUserDivision$Request>) {
  try {
    yield api.users.setUserDivision(action.payload)
    yield put({ type: String(getWhoAmI) })
    yield put({ type: String(getCompanyDivisions) })
  } catch (e: any) {
    let content: any = getErrorMsg(
      e.message && e.message !== 'No message has been provided by the server' ? e.message : 'team change',
    )
    if (e.message && e.message === 'maxTeamSizeReached') {
      content = t`Sorry, the selected team has reached its maximum size. Please select another team!`
      // Load teams list again.
      yield put({ type: String(getWhoAmI) })
    }
    const errorNotification: INotification = {
      type: 'warning',
      content,
    }
    yield put({ type: String(addNotification), payload: errorNotification })
    scrollToTop()
  }
}

function* sagaSetUserCountry(action: Action<SetUserCountry$Request>) {
  try {
    yield api.users.setUserCountry(action.payload)
    yield put({ type: String(getWhoAmI) })
  } catch (e: any) {
    const toggleErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('user country change'),
    }

    yield put({ type: String(addNotification), payload: toggleErrorNotification })
  }
}

function* sagaSetScreenOrientation({ payload }: Action<ScreenOrientation>) {
  try {
    yield call(api.users.changeUserScreenOrientation, { screenOrientation: payload })
    yield call(applyScreenOrientation, payload)
    yield put({ type: String(getWhoAmI) })
  } catch (e: any) {
    const errorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('screen orientation change'),
    }
    yield put({ type: String(addNotification), payload: errorNotification })
  }
}

function* sagaTogglePublicStatus() {
  try {
    yield api.users.togglePublicStatus()
    yield put({ type: String(getWhoAmI) })
  } catch (e: any) {
    const toggleErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('public challenge opt-in change'),
    }
    yield put({ type: String(addNotification), payload: toggleErrorNotification })
  }
}

/**
 * Saga to handle updating both user division and country in one action
 */
function* sagaUpdateUserCompanyProfile(
  action: Action<{
    userId: string
    companyId: CompanyId
    divisionId?: string
    country?: string
  }>,
) {
  try {
    console.log('Starting user company profile update')
    yield put({ type: String(updateUserCompanyProfileLoading), payload: true })

    const { userId, companyId, divisionId, country } = action.payload
    console.log('Update params:', { userId, companyId, divisionId, country })

    // Check if there's actually anything to update
    if (!divisionId && !country) {
      console.log('No division or country specified, nothing to update')
      // Still count this as success, but don't show a notification
      yield put({ type: String(updateUserCompanyProfileSuccess) })
      return
    }

    let success = true
    let changesMade = false
    let errorOccurred = false

    // Only call setUserDivision if divisionId is provided
    if (divisionId) {
      try {
        yield call(api.users.setUserDivision, {
          userId,
          companyId,
          divisionId,
        })
        changesMade = true
      } catch (error: any) {
        success = false
        errorOccurred = true
        const errorMsg =
          error.message && error.message !== 'No message has been provided by the server'
            ? error.message
            : 'team change'

        let content: React.ReactNode = getErrorMsg(errorMsg)
        if (error.message && error.message === 'maxTeamSizeReached') {
          content = t`Sorry, the selected team has reached its maximum size. Please select another team!`
          // Load teams list again
          yield put({ type: String(getWhoAmI) })
          yield put({ type: String(getCompanyDivisions) })
        }

        const errorNotification: INotification = {
          type: 'warning',
          content,
        }
        yield put({ type: String(addNotification), payload: errorNotification })
      }
    }

    // Only call setUserCountry if country is provided
    if (country) {
      try {
        yield call(api.users.setUserCountry, {
          userId,
          companyId,
          country,
        })
        changesMade = true
      } catch (error: any) {
        success = false
        errorOccurred = true
        const errorNotification: INotification = {
          type: 'warning',
          content: getErrorMsg('user country change'),
        }
        yield put({ type: String(addNotification), payload: errorNotification })
      }
    }

    // Update user data if at least one operation succeeded
    yield put({ type: String(getWhoAmI) })

    // Set final state based on success/error
    if (errorOccurred) {
      console.log('Profile update had errors, keeping dialog open')
      yield put({ type: String(updateUserCompanyProfileFail) })
    } else if (success) {
      // Only dispatch success if both operations succeeded
      console.log('Profile update successful, dispatching success')
      yield put({ type: String(updateUserCompanyProfileSuccess) })

      // Only show success notification if we actually made changes
      if (changesMade) {
        const successNotification: INotification = {
          type: 'success',
          content: t`Profile successfully updated`,
        }
        yield put({ type: String(addNotification), payload: successNotification })
      }
    } else {
      console.log('Profile update partially failed, dispatching fail')
      yield put({ type: String(updateUserCompanyProfileFail) })
    }
  } catch (error: any) {
    console.log('Profile update error:', error)
    yield put({ type: String(updateUserCompanyProfileFail) })

    const errorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('profile update'),
    }
    yield put({ type: String(addNotification), payload: errorNotification })
  } finally {
    console.log('Profile update process completed')
  }
}

export function* settingsSagas() {
  yield all([
    //takeEvery(String(getUserActivity), sagaGetUserActivity),
    takeEvery(String(getUserCompanyCountries), sagaGetUserCompanyCountries),
    takeEvery(String(getCompanyDivisions), sagaGetCompanyDivisions),
    takeEvery(String(deleteUser), sagaDeleteUser),
    takeEvery(String(changePassword), sagaChangePassword),
    takeEvery(String(updateUser), sagaUpdateUser),
    takeEvery(String(joinCompany), sagaJoinCompany),
    takeEvery(String(leaveCompany), sagaLeaveCompany),
    takeEvery(String(deleteUserOwnedCompany), sagaDeleteUserOwnedCompany),
    takeEvery(String(setUserDivision), sagaSetUserDivision),
    takeEvery(String(setUserCountry), sagaSetUserCountry),
    takeEvery(String(togglePublicStatus), sagaTogglePublicStatus),
    takeEvery(String(updateUserCompanyProfile), sagaUpdateUserCompanyProfile),
    takeEvery(String(setScreenOrientation), sagaSetScreenOrientation),
  ])
}
